<div class="whatsapp-settings-container">
  <h3 class="settings-title">{{ 'BARDO_WHATSAPP.CONFIGURACOES.TITULO' | translate }}</h3>
  <p class="settings-subtitle">
    {{ 'BARDO_WHATSAPP.CONFIGURACOES.SUBTITULO' | translate }}
  </p>

  <form [formGroup]="settingsForm">
    <p-accordion [multiple]="true" styleClass="settings-accordion">
      <!-- Chamadas -->
      <p-accordion-panel value="0">
        <p-accordion-header>
          <span>{{ 'BARDO_WHATSAPP.CONFIGURACOES.CHAMADAS' | translate }}</span>
        </p-accordion-header>
        <p-accordion-content>
          <div class="tab-content">
            <div class="field">
              <label for="rejectCalls" class="field-label">
                {{ 'BARDO_WHATSAPP.CONFIGURACOES.REJEITAR_CHAMADAS' | translate }}
              </label>
              <p-toggleSwitch
                formControlName="rejectCalls"
                inputId="rejectCalls"
              ></p-toggleSwitch>
              <small class="field-description">
                {{ 'BARDO_WHATSAPP.CONFIGURACOES.REJEITAR_CHAMADAS_DESC' | translate }}
              </small>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>

      <!-- Privacidade -->
      <p-accordion-panel value="1">
        <p-accordion-header>
          <span>{{ 'BARDO_WHATSAPP.CONFIGURACOES.PRIVACIDADE' | translate }}</span>
        </p-accordion-header>
        <p-accordion-content>
          <div class="tab-content">
            <div class="field">
              <label for="alwaysOnline" class="field-label">
                {{ 'BARDO_WHATSAPP.CONFIGURACOES.SEMPRE_ONLINE' | translate }}
              </label>
              <p-toggleSwitch
                formControlName="alwaysOnline"
                inputId="alwaysOnline"
              ></p-toggleSwitch>
              <small class="field-description">
                {{ 'BARDO_WHATSAPP.CONFIGURACOES.SEMPRE_ONLINE_DESC' | translate }}
              </small>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>

      <!-- Filtros de Mensagens -->
      <p-accordion-panel value="2">
        <p-accordion-header>
          <span>{{ 'BARDO_WHATSAPP.CONFIGURACOES.FILTROS' | translate }}</span>
        </p-accordion-header>
        <p-accordion-content>
          <div class="tab-content">
            <div class="field">
              <label for="ignoreGroups" class="field-label">
                {{ 'BARDO_WHATSAPP.CONFIGURACOES.IGNORAR_GRUPOS' | translate }}
              </label>
              <p-toggleSwitch
                formControlName="ignoreGroups"
                inputId="ignoreGroups"
              ></p-toggleSwitch>
              <small class="field-description">
                {{ 'BARDO_WHATSAPP.CONFIGURACOES.IGNORAR_GRUPOS_DESC' | translate }}
              </small>
            </div>

            <div class="field">
              <label for="ignoreBroadcasts" class="field-label">
                {{ 'BARDO_WHATSAPP.CONFIGURACOES.IGNORAR_TRANSMISSAO' | translate }}
              </label>
              <p-toggleSwitch
                formControlName="ignoreBroadcasts"
                inputId="ignoreBroadcasts"
              ></p-toggleSwitch>
              <small class="field-description">
                {{ 'BARDO_WHATSAPP.CONFIGURACOES.IGNORAR_TRANSMISSAO_DESC' | translate }}
              </small>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>

      <!-- Experiência do Usuário -->
      <p-accordion-panel value="3">
        <p-accordion-header>
          <span>{{ 'BARDO_WHATSAPP.CONFIGURACOES.EXPERIENCIA' | translate }}</span>
        </p-accordion-header>
        <p-accordion-content>
          <div class="tab-content">
            <div class="field">
              <label for="automaticSchedule" class="field-label">
                {{ 'BARDO_WHATSAPP.CONFIGURACOES.AGENDAMENTO_AUTOMATICO' | translate }}
              </label>
              <p-toggleSwitch
                formControlName="automaticSchedule"
                inputId="automaticSchedule"
              ></p-toggleSwitch>
              <small class="field-description">
                {{ 'BARDO_WHATSAPP.CONFIGURACOES.AGENDAMENTO_AUTOMATICO_DESC' | translate }}
              </small>
            </div>
          </div>
          <div class="tab-content">
            <div class="field">
              <label for="typingSimulation" class="field-label">
                {{ 'BARDO_WHATSAPP.CONFIGURACOES.CONFIRMACAO_AUTOMATICA' | translate }}
              </label>
              <p-toggleSwitch
                formControlName="automaticScheduleConfirmation"
                inputId="automaticScheduleConfirmation"
              ></p-toggleSwitch>
              <small class="field-description">
                {{ 'BARDO_WHATSAPP.CONFIGURACOES.CONFIRMACAO_AUTOMATICA_DESC' | translate }}
              </small>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>

    <!-- Informação -->
    <div class="info-message">
      <i class="pi pi-info-circle"></i>
      <span [innerHTML]="'BARDO_WHATSAPP.CONFIGURACOES.INFO_IMEDIATA' | translate"></span>
    </div>

    <!-- Ações -->
    <div class="actions">
      <p-button
        [label]="'BARDO_WHATSAPP.CONFIGURACOES.RESTAURAR_PADROES' | translate"
        icon="pi pi-refresh"
        [outlined]="true"
        severity="secondary"
        (onClick)="restaurarPadroes()"
        [disabled]="$salvando()"
      />

      <p-button
        [label]="'BARDO_WHATSAPP.CONFIGURACOES.SALVAR_CONFIGURACOES' | translate"
        icon="pi pi-save"
        [loading]="$salvando()"
        (onClick)="salvar()"
      />
    </div>
  </form>
</div>
